"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryArea", {
  enumerable: true,
  get: function () {
    return _victoryArea.default;
  }
});
Object.defineProperty(exports, "Area", {
  enumerable: true,
  get: function () {
    return _area.default;
  }
});

var _victoryArea = _interopRequireDefault(require("./victory-area"));

var _area = _interopRequireDefault(require("./area"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-area/lib/index.js
// module id = 1839
// module chunks = 0